export default class IdleAnimations {
  constructor() {
    this.ids = ['character-slot-first', 'character-slot-second', 'character-slot-third', 'character-slot-fourth'];

    this.animationsPlaying = false;
    this.animationId = false;
    this.idleTimer = null;
    this.animationTimer = null;

    this.triggerAnimations = this.triggerAnimations.bind(this);
    this.resetIdleTimer = this.resetIdleTimer.bind(this);

    // check if first element is present
    if (document.getElementById(this.ids[0])) {
      this.addEvents();
      this.resetIdleTimer();
    }
  }

  addEvents() {
    // Reset the idle timer and animation timer on user activity
    document.addEventListener('mousemove', () => {
      this.resetIdleTimer();
      clearTimeout(this.animationTimer);
      this.animationTimer = null;
      document.getElementById(this.animationId)?.classList?.remove('bounce');
    });
    document.addEventListener('click', () => {
      this.resetIdleTimer();
      clearTimeout(this.animationTimer);
      this.animationTimer = null;
      document.getElementById(this.animationId)?.classList?.remove('bounce');
    });
  }

  triggerAnimations() {
    setTimeout(() => {
      // Randomly select a character from the list and add "bounce" class name to the element
      const randomId = Math.floor(Math.random() * this.ids.length);

      document.getElementById(this.ids[randomId]).classList.add('bounce');
      this.animationId = this.ids[randomId];
      this.animationsPlaying = true;

      this.resetAnimationTimer(randomId);
    }, 500);
  }

  resetAnimationTimer() {
    this.animationTimer = setTimeout(() => {
      document.getElementById(this.animationId).classList.remove('bounce');
      this.animationsPlaying = false;

      clearTimeout(this.animationTimer);
      this.animationTimer = null;

      this.triggerAnimations();
    }, 2500);
  }

  resetIdleTimer() {
    document.getElementById(this.animationId) && document.getElementById(this.animationId).classList.remove('bounce');

    this.animationsPlaying = false;
    clearTimeout(this.idleTimer);

    this.idleTimer = null;

    this.idleTimer = setTimeout(() => {
      this.triggerAnimations();
    }, 4000);
  }
}
